import { getEntitlements } from 'API/compassRights';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { useAppSelector, useIsDesktop } from 'Hooks';
import { useCallback, useContext, useEffect, useState } from 'react';
import {
  sessionCategoriesFilter,
  sessionTextSearch,
} from 'reducer/CompassRights/EntitlementsReducer';
import { CompassHeader } from './CompassHeader';
import { IntroBubbleInfo } from './IntroBubbleInfo';
import { UserEntitlementsPanel } from './UserEntitlementsPanel';
import { useLoader } from 'Hooks/useLoader';
import { Stack } from '@mui/material';

export const CompassRightsContextWrapper = () => {
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const { dispatchEntitlements } = useContext(EntitlementsContext);
  const [lastUpdateDate, setLastUpdateDate] = useState<Date | undefined>(
    undefined
  );
  const isDesktop = useIsDesktop();
  const { isLoading, setIsLoading, loader } = useLoader();

  const initCompassRights = useCallback(async () => {
    setIsLoading(true);
    const entitlementsResult = await getEntitlements();
    if (entitlementsResult?.data) {
      const { userEntitlements, lastUpdateDate } = entitlementsResult.data;
      setLastUpdateDate(lastUpdateDate);
      dispatchEntitlements({
        type: 'INITIALIZATION',
        payload: { value: userEntitlements || [] },
      });
      setIsLoading(false);
    }
  }, [setIsLoading, dispatchEntitlements]);

  useEffect(() => {
    initCompassRights();

    const clearSessionStorage = () => {
      sessionStorage.removeItem(sessionCategoriesFilter);
      sessionStorage.removeItem(sessionTextSearch);
    };
    window.addEventListener('beforeunload', clearSessionStorage);

    return () => {
      window.removeEventListener('beforeunload', clearSessionStorage);
    };
  }, [initCompassRights, imposterId]);

  return (
    <>
      <CompassHeader lastUpdateDate={lastUpdateDate} />
      <Stack gap={isDesktop ? '48px' : '40px'}>
        <IntroBubbleInfo />
        {isLoading ? loader : <UserEntitlementsPanel />}
      </Stack>
    </>
  );
};
